// 落地页/启动页（枚举与展示函数；数据走真接口 @/api/launch）
// 对应小程序启动时的开屏落地页：logo + 宣传语 + 跳过倒计时 + 底部「了解更多」图文/跳转
// 可配置多个版本（如"默认版""国庆版""春节版"），同一时间可启用多个，小程序取启用中的最新版

export const LAUNCH_STATUS = [
  { value: 1, label: '启用', tagType: 'success' },
  { value: 0, label: '停用', tagType: 'info' }
]

export function launchStatusText(status) {
  const item = LAUNCH_STATUS.find(s => s.value === status)
  return item ? item.label : String(status)
}

export function launchStatusTagType(status) {
  const item = LAUNCH_STATUS.find(s => s.value === status)
  return item ? item.tagType : 'info'
}

// 宣传语数组 → 展示文本
export function sloganText(slogan) {
  if (!Array.isArray(slogan) || !slogan.length) return '—'
  return slogan.join(' / ')
}

// 跳转目标展示：空 → 站内图文（了解更多展开）
export function launchJumpText(row) {
  if (row.jump_url) return row.jump_url
  return '站内图文（了解更多展开）'
}
